<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('STAT_SIMU')">
        <slot name="section-stat-simu">
          <section-stat-simu ref="STAT_SIMU"
                             id="STAT_SIMU"
                             :extended="isExtended('STAT_SIMU')"
                             :showButton="true"
                             :autoSave="true"
                             :readOnly="readOnly"
                             :moduleId="moduleId"
                             :searchText="searchText"
                             :ressourceHeader="ressource"
                             :fiche="fiche"
                             :simulation=selectedSimulation
                             :route="route"
                             :attribut="attribut"
                             @extended="setExtended"
                             @fullscreen="setFullscreen"
                             @status="updateStatus"
                             @updated="simulationUpdated"
                             @selectItem = "selectItem">
          </section-stat-simu>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('LIST_SIMU')">
        <slot name="section-list-simu">
          <section-list-simu ref="LIST_SIMU"
                             id="LIST_SIMU"
                             :extended="isExtended('LIST_SIMU')"
                             :showButton="true"
                             :autoSave="true"
                             :readOnly="readOnly"
                             :moduleId="moduleId"
                             :searchText="searchText"
                             :ressourceHeader="ressource"
                             :fiche="fiche"
                             :simulation=selectedSimulation
                             :route="route"
                             :attribut="attribut"
                             @extended="setExtended"
                             @fullscreen="setFullscreen"
                             @status="updateStatus"
                             @updated="simulationUpdated"
                             @selectItem = "selectItem">
          </section-list-simu>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Simulation from '@/extend/classes/Simulation';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionStatSimu from '@/custom/sections/SectionStatSimu.vue';
import SectionListSimu from '@/custom/sections/SectionListSimu.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionStatSimu,
    SectionListSimu,
    FicheHeader,
  },

  props: {
    simulation: {
      type: Object as PropType<Simulation>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.SIMULATION,
      sections: [
        'STAT_SIMU',
        'LIST_SIMU',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_SIMULATION);
    },

    selectedSimulation (): Simulation {
      return this.simulation
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    simulationUpdated (simulation: Simulation) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.simulation || this.simulation.id < 0) && value == 'STAT_SIMU') {
        this.setExtended(new Extended('STAT_SIMU', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
